module.exports = __webpack_public_path__ + "img/game_main_pc_36_off.3e03e862.png";